import styled from "styled-components"

import { media } from "src/uikit"

export const Container = styled.div`
  background-color: ${props => (props.transparent ? "transparent" : "#fff")};
  border-radius: 18px;

  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    min-width: ${props => (props.modalType ? "100%" : "400px")};
    border-radius: ${props => (props.modalType ? "0 0 18px 18px" : "12px")};
    margin-top: ${props => (props.modalType ? 28 : 32)}px;
  }

  @media ${media.mobile} {
    button {
      min-width: 100%;
    }
  }
`

export const FormContainer = styled.form`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  padding: ${props => (props.modalType ? "32px 24px 0 24px" : "0")};

  > div {
    flex-basis: calc(50% - 8px);
  }

  > div:nth-child(2n + 1) {
    margin-right: 8px;
  }

  > div:nth-child(2n) {
    margin-left: 8px;
  }

  > div:last-child {
    flex-basis: 100%;
    margin: 0;
  }

  @media ${media.mobile} {
    padding: ${props => (props.modalType ? "16px 16px 0 16px" : "0")};

    > div,
    > div:nth-child(2n),
    > div:nth-child(2n + 1) {
      flex-basis: 100%;
      margin: 0;
    }
  }
`
